import { Component, inject } from '@angular/core';
import { H2Component } from '@design-system/typography/h2/h2.component';
import { PComponent } from '@design-system/layout/p/p.component';
import { ButtonComponent } from '@design-system/buttons/button/button.component';
import { CommonModule, Location } from '@angular/common';
import { environment } from '@env/environment';
import { H1Component } from '@design-system/typography/h1/h1.component';
import { H3Component } from '@design-system/typography/h3/h3.component';

@Component({
  selector: 'app-unauthorised',
  standalone: true,
  imports: [
    H1Component,
    H2Component, 
    H3Component,
    PComponent, 
    ButtonComponent, 
    CommonModule,

  ],
  templateUrl: './unauthorised.component.html',
  styleUrl: './unauthorised.component.scss'
})
export class UnauthorisedComponent {
  private location = inject(Location);
  isDevelopment = environment.environment === 'local' || environment.environment === 'development';

  goBack() {
    this.location.back();
  }
}
